import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { PlayGamesService } from '@app/core/play-games/play-games.service';
import {
  ACHIEVEMENT_IDS,
  PlayGamesAchievementId,
  PlayGamesStatsId,
  GameStatPayload,
  GAME_STAT_PAYLOAD_KEYS,
} from '@app/core/play-games/play-games.model';

@Component({
  selector: 'slotcom-tester-play-games-options',
  standalone: true,
  imports: [FormsModule, SharedModule, ButtonComponent],
  templateUrl: './play-games-options.component.html',
  styleUrl: '../tester-modal.component.scss',
})
export class PlayGamesOptionsComponent {
  private readonly playGamesService = inject(PlayGamesService);

  readonly incrementAmount = signal(1);
  readonly statAmounts = signal<Record<string, number>>({});

  protected readonly achievementEntries = Object.entries(ACHIEVEMENT_IDS) as [string, PlayGamesAchievementId][];
  protected readonly statPayloadKeys = GAME_STAT_PAYLOAD_KEYS as readonly GameStatPayload[];

  unlockAchievement(id: PlayGamesAchievementId) {
    this.playGamesService.unlockAchievement(id);
  }

  incrementAchievement(id: PlayGamesAchievementId) {
    this.playGamesService.incrementAchievement(id, this.incrementAmount());
  }

  isAchievementButtonDisabled(id: PlayGamesAchievementId, index: number): boolean {
    if (this.playGamesService.isUnlocked(id)) return true;
    if (index === 0) return false;
    return !this.playGamesService.isUnlocked(this.achievementEntries[index - 1][1]);
  }

  getStatAmount(key: GameStatPayload): number {
    return this.statAmounts()[key] ?? 1;
  }

  setStatAmount(key: GameStatPayload, value: number): void {
    this.statAmounts.update((prev) => ({ ...prev, [key]: value }));
  }

  sendGameStat(key: GameStatPayload): void {
    const eventId: PlayGamesStatsId = key === 'currentProgress' ? 'progressUpdate' : 'stats';
    this.playGamesService.sendGameStat(eventId, { [key]: this.getStatAmount(key) });
  }
}
